import React from "react";
import { STEPS } from "../../constants/steps";

const ContractStepper = ({ currentStep, completedSteps = [], onStepClick, validationErrors = {} }) => {
  return (
    <div className="stepper-container">
      <div className="stepper-scroll">
        <div className="stepper-track">
          {STEPS.map((step, index) => {
            const hasErrors = validationErrors[step.id] && Object.keys(validationErrors[step.id]).length > 0;
            return (
              <React.Fragment key={step.id}>
                <div
                  className={`stepper-item ${
                    currentStep === step.id ? "active" : ""
                  } ${completedSteps.includes(step.id) ? "completed" : ""} ${
                    hasErrors ? "has-errors" : ""
                  }`}
                  onClick={() => onStepClick(step.id)}
                >
                  <div className="step-number">
                    {hasErrors ? (
                      <span className="step-error-icon">!</span>
                    ) : (
                      step.id
                    )}
                  </div>
                  <div className="step-label">{step.label}</div>
                </div>
                {index < STEPS.length - 1 && (
                  <div
                    className={`stepper-connector ${
                      completedSteps.includes(step.id) ? "completed" : ""
                    }`}
                  />
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ContractStepper;
